/**
 * PipelinesTab — Saved pipelines list for the sidebar toolbar.
 */

import { Layers } from 'lucide-react';
import React from 'react';

import { PipelineList } from '@/components/app/PipelineList';
import type { ISavedPipeline } from '@/interfaces/IStorage';

export interface PipelinesTabProps {
  sortedPipelines: ISavedPipeline[];
  onOpenPipeline: (pipeline: ISavedPipeline) => void;
  onEditPipeline: (pipeline: ISavedPipeline) => void;
  onDeletePipeline: (pipeline: ISavedPipeline) => void;
}

export const PipelinesTab: React.FC<PipelinesTabProps> = ({
  sortedPipelines,
  onOpenPipeline,
  onEditPipeline,
  onDeletePipeline,
}) => {
  if (sortedPipelines.length === 0) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center gap-2 px-4 py-8 text-center">
        <Layers className="h-8 w-8 text-muted-foreground/40" />
        <div className="text-sm text-muted-foreground">No saved pipelines</div>
        <div className="text-xs text-muted-foreground/70">
          Save a pipeline to create your first pipeline
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto px-2 pb-4">
      <div className="p-1">
        <PipelineList
          pipelines={sortedPipelines}
          onOpen={onOpenPipeline}
          onEdit={onEditPipeline}
          onDelete={onDeletePipeline}
        />
      </div>
    </div>
  );
};
